import { render } from "./solved_complaints.vue?vue&type=template&id=672f2934"
import script from "./solved_complaints.vue?vue&type=script&lang=js"
export * from "./solved_complaints.vue?vue&type=script&lang=js"

import "./solved_complaints.vue?vue&type=style&index=0&id=672f2934&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__